import { useEffect, useRef, useState } from "react";
import {  useLocation } from "react-router-dom";
import { MdAccessTime, MdClose, MdDateRange, MdDelete, MdDeleteOutline, MdOutlineMenu } from "react-icons/md";
import { TriggerStore } from "../../../Store";
import { useUserAuth } from "../../../hook/useAuth";
import { Config } from "../../../config/config";
import { BsBellFill } from "react-icons/bs";
import ProfileDrawer from "../components/profileDrawer";
import { useNotifications } from "../../../hook/useNotification";
import { useProfile } from "../../../hook/useProfile";
import toast from "react-hot-toast";
import { FaSpinner } from "react-icons/fa";
import { TbBellRinging2Filled } from "react-icons/tb";

interface Notification {
  id: number;
  action: string;
  performedBy: string;
  timestamp: string; // Use Date if you want to handle it as a Date object
  details: string;
}

export const Header = () => {
  const { logout, User } = useUserAuth();
  const { Profile } = useProfile();
  const userId = localStorage.getItem("R_M_uid");

  const data = Profile(userId);
  const { Notification ,deleteNotification} = useNotifications(); // Fetch notifications from the hook

  let user;
  let userName;
  let userEmail;
  if (
    window.location.href !== `${Config.feUrl}/` &&
    window.location.href !== `${Config.feUrl}/logout`
  ) {
    user = User(userId as string);
    userName = user.data === undefined ? "." : user.data?.userName;
    userEmail = user.data === undefined ? "." : user.data?.userEmail;
  }
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [showProfileDrawer, setShowProfileDrawer] = useState<boolean>(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [newNotificationCount, setNewNotificationCount] = useState<number>(0);
  const { setSideTrigger, setSideAction, sidebartrigger } = TriggerStore(
    (state) => state
  );
  const location = useLocation();

  const toggleSidebar = () => {
    setSideTrigger(!sidebartrigger);
    setSideAction(true);
  };

// Add a ref for the notification dropdown
const notificationRef = useRef<HTMLDivElement>(null);
const bellIconRef = useRef<HTMLDivElement>(null);

// Handle outside click to close dropdown
useEffect(() => {
  function handleClickOutside(event: MouseEvent) {
    if (
      notificationRef.current && 
      !notificationRef.current.contains(event.target as Node) &&
      bellIconRef.current &&
      !bellIconRef.current.contains(event.target as Node)
    ) {
      setShowDropdown(false);
    }
  }
// Add event listener when dropdown is open
if (showDropdown) {
  document.addEventListener('mousedown', handleClickOutside);
}

return () => {
  document.removeEventListener('mousedown', handleClickOutside);
};
}, [showDropdown]);

// Close dropdown when route changes
useEffect(() => {
setShowDropdown(false);
}, [location.pathname]);

  const isLoginPage = location.pathname === "";

  const handleNotificationClick = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      // Reset new notification count when dropdown is opened
      setNewNotificationCount(0);
    }
  };

  const toggleProfileDrawer = () => {
    if (
      window.location.href !== `${Config.feUrl}/logout` &&
      window.location.href !== `${Config.feUrl}/`
    ) {
      setShowProfileDrawer(!showProfileDrawer);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => setCurrentDateTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Retrieve the notification count from local storage on component mount
    const storedCount = localStorage.getItem("newNotificationCount");
    if (storedCount) {
      setNewNotificationCount(Number(storedCount));
    }
  }, []);

  useEffect(() => {
    const fetchNotifications = () => {
      if (Notification.data) {
        const newNotifications = Notification.data; // Assuming Notification.data is an array of notifications
        const oldCount = notifications.length;
        const newCount = newNotifications.length;

        // Update notifications state
        setNotifications(newNotifications as any);

        // Calculate new notification count
        const newMessagesCount = newCount - oldCount;

        // Update new notification count if there are new notifications
        if (newMessagesCount > 0) {
          setNewNotificationCount(newMessagesCount);
          // Store the new notification count in local storage
          localStorage.setItem(
            "newNotificationCount",
            String(newMessagesCount)
          );
        } else {
          // If no new messages, reset the count
          setNewNotificationCount(0);
          localStorage.setItem("newNotificationCount", "0");
        }
      }
    };

    fetchNotifications();
  }, [Notification.data]);


  const handleDelete = async (id: any) => {
    setDeletingId(id); 
    try {
      await deleteNotification.mutateAsync(id);
      toast.success("Notification deleted successfully!");
      setDeletingId(null)
    } catch (error) {
      setDeletingId(null)
      toast.error("Failed to delete the notification. Please try again.");
      console.error("Delete Notification Error:", error);
    }
  };

  // Update local storage whenever newNotificationCount changes
  useEffect(() => {
    localStorage.setItem("newNotificationCount", String(newNotificationCount));
  }, [newNotificationCount]);

  const handleLogout = () => {
    logout.mutateAsync();
  };

  return (
    <div className="flex w-full bg-white px-5 justify-between items-center md:h-[8vh] z-50 xl:h-[8vh] shadow-md">
      {!isLoginPage && (
        <div className="xl:hidden hover:bg-slate-100 hover:rounded-full">
          <button onClick={toggleSidebar} className="p-2 text-primary">
            <MdOutlineMenu className="h-8 w-8" />
          </button>
        </div>
      )}

      <button className="text-dark lg:text-primary text-sm md:text-lg text-start px-2 md:text-dark font-bold capitalize w-full">
        Selvam Rental Management
      </button>

      {!isLoginPage && (
        <div className="flex items-center text-sm w-full">
          <div className="flex items-center gap-2 ml-auto">
            <div
              onClick={handleNotificationClick}
              className="relative cursor-pointer"
            >
            {/* {showDropdown?<TbBellRinging2Filled className="h-6 w-6"/>:  <BsBellFill className="h-5 w-5" />}  

            
              {newNotificationCount > 0 && !showDropdown && (
                <span className="absolute top-[-8px] right-[-8px] h-4 w-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                  {newNotificationCount}
                </span>
              )} */}
               <div 
        ref={bellIconRef}
        onClick={handleNotificationClick}
        className="relative cursor-pointer"
      >
        {showDropdown ? (
          <TbBellRinging2Filled className="h-6 w-6"/>
        ) : (
          <BsBellFill className="h-5 w-5" />
        )}  
        
        {newNotificationCount > 0 && !showDropdown && (
          <span className="absolute top-[-8px] right-[-8px] h-4 w-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
            {newNotificationCount}
          </span>
        )}
      </div>
            </div>
            <div className="flex-col hidden xl:flex items-end text-gray-600 gap-1 px-1 md:flex md:text-sm sm:text-xs">
              <span className="flex items-center gap-1">
                <span className="font-medium text-sm sm:text-xs">
                  {currentDateTime.toLocaleDateString()}
                </span>
                <MdDateRange className="h-4 w-4 sm:h-3 sm:w-3 text-primary" />
              </span>
              <span className="flex items-center gap-1">
                <span className="font-medium text-sm sm:text-xs">
                  {currentDateTime.toLocaleTimeString()}
                </span>
                <MdAccessTime className="h-4 w-4 sm:h-3 sm:w-3 text-primary" />
              </span>
            </div>

            <div className="relative">
              <div className="flex gap-3 items-end justify-end pl-2 pr-0 h-10 w-14 text-gray-800 cursor-pointer">
                {window.location.href !== `${Config.feUrl}/logout` &&
                window.location.href !== `${Config.feUrl}/` ? (
                  <img
                    onClick={toggleProfileDrawer}
                    className="flex-shrink-0 object-cover object-center w-10 h-10 border rounded-full cursor-pointer"
                    src={
                      data.data === undefined
                        ? `https://via.placeholder.com/200x200.png?text=${
                            user?.isLoading || userName === undefined
                              ? "."
                              : userName.charAt(0).toUpperCase()
                          }`
                        : `data:image/png;base64,${(data as any).data.data}`
                    }
                  />
                ) : null}
              </div>

              {showDropdown && (
          <div
          ref={notificationRef}
          className="absolute right-0 mt-2 w-80 md:w-96 max-h-72 overflow-auto bg-white shadow-lg rounded-lg border">
            <div className="w-full p-2 flex items-center  shadow-md sticky top-0 justify-between bg-green-50">
                  <p className="text-xl text-primary">Notifications</p>
                   <button
                   title="notification"
                   className="text-primary hover:text-secondary  hover:bg-primary/10 p-2 rounded-full transition duration-150"
                   onClick={() =>setShowDropdown(false)}
                    >
                   <MdClose size={20}/>
                   </button>
                </div>
          {notifications.length > 0 ? (
            notifications.map((notification) => (
              <div
                key={notification.id}
                className="p-4 border-b last:border-b-0 hover:bg-primary/5 transition duration-200 flex flex-col space-y-2"
              >
                
                <div className="flex items-center justify-between">
                  {/* Date Display */}
                  <span className="text-gray-500 text-sm">
                    {new Date(notification.timestamp).toLocaleString()}
                  </span>
    
                  {/* Delete Button */}
                  <button
                    title="delete"
                    className="text-red-500 hover:text-red-700  hover:bg-red-100 p-2 rounded-full transition duration-150"
                    onClick={() => handleDelete(notification.id)}
                  >
                    {deletingId === notification.id ? (
                      <FaSpinner className="animate-spin" />
                    ) : (
                      <MdDeleteOutline size={25} />
                    )}
                  </button>
                </div>
    
                {/* Notification Details */}
                {/* <p className="text-gray-700 font-semibold text-sm break-words"> */}
                {/* <p className="text-gray-700 text-sm break-words">
                  {notification.details}
                </p> */}
                <p className="text-gray-700 text-sm break-words">
  <pre className="whitespace-pre-wrap font-sans">{notification.details}</pre>
</p>
              </div>
            ))
          ) : (
            <div className="p-6 text-center text-gray-500">No notifications</div>
          )}
        </div>
    
           
             
              )}
            </div>
          </div>
        </div>
      )}

      {/* Profile Drawer */}
      {showProfileDrawer && (
        <ProfileDrawer
          userName={userName}
          user={user}
          toggleProfileDrawer={toggleProfileDrawer}
          handleLogout={handleLogout}
          logout={logout}
        />
      )}
    </div>
  );
};